import clsx from "clsx";
import { ElementType, PropsWithChildren, forwardRef } from "react";

const Container = forwardRef<
  HTMLElement,
  {
    className?: string;
    padding?: boolean;
    fullWidth?: boolean;
    as?: ElementType;
  } & PropsWithChildren
>(function Container({ as, children, className, padding, fullWidth }, ref) {
  const Element = as ?? "div";

  return (
    <Element
      ref={ref}
      className={clsx("w-full space-m", className, {
        "max-w-[1600px] mx-auto ": !fullWidth,
        "px-s m:px-m": padding,
        "m:px-s": !padding,
      })}
    >
      {children}
    </Element>
  );
});

export default Container;
